<div>
  <div class="add-filter">
    <div class="form-row" [formGroup]="formGroup">
      <div>
        <q9-select
          [isRequired]="true"
          formControlName="column"
          [label]="'RUBIC_CUBE.FILTER_COLUMN_LABEL' | translate"
          [disabled]="!columns.length">
          <q9-option *ngFor="let column of columns" [value]="column.field.value">
            {{ column.field.displayValue | translate }}
          </q9-option>
        </q9-select>
      </div>

      <div [hidden]="selectedColumn && !operators.length">
        <q9-select
          formControlName="operator"
          [label]="'RUBIC_CUBE.FILTER_OPERATOR_LABEL' | translate"
          [disabled]="!selectedColumn">
          <q9-option *ngFor="let operator of operators" [value]="operator.value">
            {{ operator.title }}
          </q9-option>
        </q9-select>
      </div>

      <ng-container>
        <ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
      </ng-container>

      <ng-template #string>
        <div class="text-field">
          <q9-text-field
            [isRequired]="true"
            formControlName="value"
            [label]="'RUBIC_CUBE.FILTER_VALUE_LABEL' | translate"
            [placeholder]="valuePlaceholder | translate"></q9-text-field>
        </div>
      </ng-template>

      <ng-template #integer>
        <div class="two-values-wrapper" [class.tighter]="formGroup.value.operator === 'range'">
          <div class="text-field">
            <q9-text-field
              [label]="'RUBIC_CUBE.FILTER_VALUE_LABEL' | translate "
              [isRequired]="true"
              type="number"
              formControlName="value"></q9-text-field>
          </div>

          <ng-container *ngIf="formGroup.value.operator === 'range'">
            <div class="text-field">
              <q9-text-field
                [label]="'RUBIC_CUBE.SECOND_FILTER_VALUE_LABEL' | translate"
                [isRequired]="true"
                type="number"
                formControlName="secondValue"></q9-text-field>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <ng-template #predefined>
        <div class="predefined-field">
          <q9-select
            [isRequired]="true"
            formControlName="value"
            [label]="'RUBIC_CUBE.FILTER_VALUE_LABEL' | translate">
            <q9-option
              *ngFor="let predefined of config.predefinedValues"
              [value]="predefined.value">
              {{ predefined.displayValue | subtypeConverter | translate }}
            </q9-option>
          </q9-select>
        </div>
      </ng-template>

      <ng-template #datePicker>
        <div class="two-values-wrapper" [class.tighter]="formGroup.value.operator === 'range'">
          <div class="text-field">
            <q9-datetime-picker
              formControlName="value"
              [label]="'RUBIC_CUBE.DATE' | translate"
              [isRequired]="true"
              [readonly]="true"
              [type]="'date'"
              [placeholder]="datePickerPlaceholder"></q9-datetime-picker>
          </div>
          <ng-container *ngIf="formGroup.value.operator === 'range'">
            <div class="text-field">
              <q9-datetime-picker
                formControlName="secondValue"
                [label]="'RUBIC_CUBE.DATE' | translate"
                [isRequired]="true"
                [readonly]="true"
                [type]="'date'"
                [placeholder]="datePickerPlaceholder"></q9-datetime-picker>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <ng-template #query>
        <div class="filter-node-search">
          <app-mini-node-search
            [addedParents]="config.addedParents"
            [column]="formGroup.value.column"
            (addParentNode)="onAddParent($event)"></app-mini-node-search>
        </div>
      </ng-template>

      <ng-template #tags>
        <div class="tags-container">
          <q9-tags-combobox
            [placeholder]="'CORE.TAGS.TAG_LABEL' | translate"
            [config]="tagsConfig"
            (changeTags)="updateTags($event)"
            [limit]="maxTags"
            [ngModel]="config.tagsList"
            [ngModelOptions]="{standalone: true}"></q9-tags-combobox>
        </div>
      </ng-template>

      <ng-template #predefinedList>
        <div class="predefined-field">
          <q9-select
            [multiple]="true"
            [isRequired]="true"
            formControlName="list"
            [label]="'RUBIC_CUBE.FILTER_VALUE_LABEL' | translate"
            [(ngModel)]="config.predefinedList"
            (selectionChange)="updatePredefinedList($event)">
            <q9-option
              [ngClass]="{'option-disabled': isPredefinedOptionDisabled(predefined.value)}"
              *ngFor="let predefined of config.predefinedValues"
              [value]="predefined.value"
              [disabled]="isPredefinedOptionDisabled(predefined.value)"
              [matTooltip]="(isPredefinedOptionDisabled(predefined.value)
                  ? 'RUBIC_CUBE.SELECT_LIMITATION_TOOLTIP'
                  : predefined.displayValue) | translate">
              {{ predefined.displayValue | translate }}
            </q9-option>
          </q9-select>
        </div>
      </ng-template>

      <ng-template #node_assignee>
        <div class="two-values-wrapper" [class.tighter]="formGroup.value.operator === 'range'">
          <div class="text-field">
            <app-user-search
              *ngIf="formGroup.value.operator !== 'contains'"
              class="q9-form-field q9-full-width"
              [value]="formGroup.value.value"
              (userSelected)="updateFilterValue($event)"></app-user-search>
          </div>
          <div class="text-field">
            <q9-text-field
              *ngIf="formGroup.value.operator === 'contains'"
              [label]="'RUBIC_CUBE.FILTER_VALUE_LABEL' | translate"
              [isRequired]="true"
              [placeholder]="valuePlaceholder | translate"
              formControlName="value"></q9-text-field>
          </div>
        </div>
      </ng-template>

      <ng-template #isExistsDropdown>
        <div>
          <q9-select
            [isRequired]="true"
            formControlName="value"
            [label]="'RUBIC_CUBE.FILTER_VALUE_LABEL' | translate">
            <q9-option *ngFor="let option of isExistsOptions" [value]="option.value">
              {{ option.title }}
            </q9-option>
          </q9-select>
        </div>
      </ng-template>
    </div>
  </div>

  <ng-container *ngIf="config.isParentFilter && config.addedParents.length">
    <mat-chip-listbox class="query-values">
      <mat-chip-option
        class="query-values-item"
        *ngFor="let item of config.addedParents"
        color="primary"
        [removable]="true"
        (removed)="removeParent(item)">
        {{ item.parentName }}
        <mat-icon matChipRemove svgIcon="close"></mat-icon>
      </mat-chip-option>
    </mat-chip-listbox>
  </ng-container>
</div>
